﻿import { booking_information } from "../../../v1_2/Booking/Booking_Information";

export class message_request {
    public message_type: string | null = null;
    public email: string | null = null;
    public booking_id: string | null = null;
    public booking_information: booking_information = new booking_information();
}